import { Component } from '@angular/core';

@Component({
    selector: 'ib-gift-cards-banner-promotion',
    templateUrl: './ib-gift-cards-banner-promotion.component.html',
    styleUrls: ['./ib-gift-cards-banner-promotion.component.scss']
})
export class IbGiftCardsBannerPromotionComponent {
    
}